import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a7feedc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spinner-container" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
  color: {
    type: String,
    default: 'primary'
  },
  size: {
    type: [Number, String],
    default: 64
  },
  width: {
    type: [Number, String],
    default: 8
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_progress_circular, {
      indeterminate: "",
      color: __props.color,
      size: __props.size,
      width: __props.width
    }, null, 8, ["color", "size", "width"])
  ]))
}
}

})